<template>
	<div class="container">
		<common-shell type="useWaterRecord"></common-shell>
	</div>
</template>

<script>
import CommonShell from '../comps/CommonShell.vue'

export default {
	name: 'UseWaterRecord',
	components: { CommonShell },
}
</script>
<style lang="scss" scoped>
.container {
	height: 100%;
}
</style>
